if (!customElements.get('cart-discount-form')) {
  class CartDiscountForm extends HTMLElement {
    connectedCallback() {
      const form = this.querySelector('form');

      if (!form || form.dataset.discountBound === 'true') return;

      form.dataset.discountBound = 'true';
      form.addEventListener('submit', (event) => this.applyDiscount(event));
    }

    applyDiscount(event) {
      event.preventDefault();

      const input = this.querySelector('input[name="discount_code"]');
      const button = this.querySelector('button[type="submit"]');
      const error = this.querySelector('[role="alert"]');
      const code = input?.value.trim();

      if (!code) {
        if (error) error.hidden = false;
        input?.focus();
        return;
      }

      if (error) error.hidden = true;
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Applying…';
      }

      const discountBaseUrl = this.dataset.discountBaseUrl || '/discount/';
      const checkoutUrl = this.dataset.checkoutUrl || '/checkout';
      const destination = `${discountBaseUrl}${encodeURIComponent(code)}?redirect=${encodeURIComponent(checkoutUrl)}`;

      window.location.assign(destination);
    }
  }

  customElements.define('cart-discount-form', CartDiscountForm);
}
